import { PromotionalItemOptions, PromotionResult } from '@commerce-cart-webcomponents/sdk';

type PromotionalItemOptionsNew = PromotionalItemOptions & { id?: string };
export interface SpecialOfferProductsProps {
  itemOptions: PromotionalItemOptionsNew[] | undefined;
  firedPromotions?: PromotionResult[];
  version?: SopVersion; // it will be removed once Cart migrates to latest.
  selectedProducts?: SelectedProducts;
  skipDefaultGwpSelection?: boolean;
  shouldValidateSelection?: boolean;
  minRequiredSelection?: number;
  hideBanner?: boolean;
  labels?: SopLabels;
  onMount?: (openDrawer: VoidCallback) => void;
  onCloseDrawer?: () => void;
  onSave?: (selectedProducts: SelectedProducts, onSuccess: VoidCallback, onError: VoidCallback) => void;
}

export type VoidCallback = () => void;

export interface SopLabels {
  drawerHeaderLabel?: string;
  sectionTitleLabel?: string;
  sectionInfoLabel?: string;
  saveCtaLabel?: string;
}

export interface SelectedProducts {
  [id: string]: {
    [productId: string]: SelectedProduct;
  };
}

export interface SelectedProduct {
  id?: string;
  /** @description Any id which will be required in payload creation. e.g. Cart entryId */
  entryId?: number;
  prmId?: string;
  modified?: boolean;
  giftPromotion?: boolean;
  quantity: number;
  sectionId?: string;
}

export interface PromotionalEntries {
  [key: string]: Record<string, PromotionalEntry>;
}

interface PromotionalEntry {
  quantity: number;
  entryId?: number;
}

export type { PromotionalItemOptionsNew as PromotionalItemOptions };

export interface PromotionsNameMap {
  [prmId: string]: string;
}

export enum SopVersion {
  TWO = 2,
  THREE = 3,
}
